import { useTranslation } from "@sagot/i18n";
import { Icon, Input, cn } from "@sagot/ui";
import { useState, type InputHTMLAttributes, type Ref } from "react";

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & { ref?: Ref<HTMLInputElement>; invalid?: boolean };

/** `[data-pw-toggle]`: password field with an eye / eye-off button. */
export function PasswordInput({ className, ref, ...rest }: PasswordInputProps) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} type={visible ? "text" : "password"} className={cn("pr-10", className)} {...rest} />
      <button
        type="button"
        className="absolute inset-y-0 right-0 inline-flex w-10 items-center justify-center text-fg-subtle hover:text-fg"
        aria-label={visible ? t("auth.common.hidePassword") : t("auth.common.showPassword")}
        aria-pressed={visible}
        onClick={() => {
          setVisible((v) => !v);
        }}
      >
        <Icon name={visible ? "eye-off" : "eye"} className="size-4" />
      </button>
    </div>
  );
}
